import { StarsButton as Button } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useSignup from '@swf/core/hooks/useSignup';
import { select } from '@swf/core/store';
import type { Dispatch, RootState } from '@swf/core/store';

import { TXTCLI_Join__create_account, TXTCLI_Login } from './AuthActions.messages.json';
import styles from './AuthActions.scss';

const AuthActions: React.FC = () => {
  const loading = useSelector((rootState: RootState) => !!rootState.loading?.models.auth);
  const isExternalPartnerSite = useSelector(select.cms.isExternalPartnerSite);
  const { modal } = useDispatch<Dispatch>();
  const signup = useSignup();
  const openLoginModal = useCallback(() => modal.enqueue({ path: '/auth/login' }), [modal]);
  const { code } = useSelector(select.location.getQuery);
  const isDisabled = isExternalPartnerSite ? !!code : loading;

  return (
    <div className={styles.wrapper}>
      <Button
        inverse
        variant="secondary"
        size="small"
        loading={isDisabled}
        onClick={openLoginModal}
        translation={TXTCLI_Login}
      />
      {!isExternalPartnerSite && (
        <Button size="small" onClick={signup} translation={TXTCLI_Join__create_account} />
      )}
    </div>
  );
};

export default AuthActions;
